import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    albums: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: '2',
    view: 'feed',
  },
  itemDesign: {},
  containerDesign: {},
};

export const gallerySlice = createSlice({
  name: 'gallery',
  initialState,
  reducers: {
    galleryStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = {
        shape: itemDesign.shape ?? 'round',
        border: itemDesign.border ?? 'none',
        borderColor: itemDesign.borderColor ?? '#ECECF0',
        shadow: itemDesign.shadow ?? 'none',
        shadowColor: itemDesign.shadowColor ?? '#000000',
      };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        albums: blockContent.albums ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        layout: String(blockDesign.layout ?? '2'),
        view: blockDesign.view ?? 'feed',
      };
    },
    galleryClear: () => initialState,

    galleryUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    galleryUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    // galleryUpdateBlockContent: (state, action) => {
    //   state.blockContent = action.payload;
    // },
    galleryUpdateBlockContent(state, action) {
      const { items, albums, heading } = action.payload || {};

      if (items !== undefined) {
        state.blockContent.items = Array.isArray(items) ? items : [];
      }

      if (albums !== undefined) {
        state.blockContent.albums = Array.isArray(albums) ? albums : [];
      }

      if (heading !== undefined) {
        state.blockContent.heading = {
          ...state.blockContent.heading,
          ...heading,
        };
      }
    },

    galleryUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { galleryStore, galleryClear, galleryUpdateIsLoading, galleryUpdateIsActive, galleryUpdateBlockContent, galleryUpdateBlockDesign } = gallerySlice.actions;

export const selectGalleryIsLoading = (state) => state.gallery.isLoading;

export const selectGalleryId = (state) => state.gallery.id;
export const selectGalleryUID = (state) => state.gallery.uid;
export const selectGallerySID = (state) => state.gallery.sid;

export const selectGalleryBlockContent = (state) => state.gallery.blockContent;
export const selectGalleryBlockDesign = (state) => state.gallery.blockDesign;
// export const selectGallerySortItems = createSelector([selectGalleryBlockContent], ({ items }) => {
//   return sortItems(items);
// });
export const selectGallerySortItems = createSelector(selectGalleryBlockContent, (blockContent) => sortItems(blockContent?.items || []));

export const selectGalleryAlbums = createSelector(selectGalleryBlockContent, (blockContent) => [...(blockContent?.albums || [])].sort((a, b) => (a.n ?? 0) - (b.n ?? 0)));

export const selectGalleryItemDesign = (state) => state.gallery.itemDesign;
export const selectGalleryContainerDesign = (state) => state.gallery.containerDesign;

export default gallerySlice.reducer;
